import React from "react";
import searchIcon from "../../../assets/img/svg/search-icon.svg";
import filterIcon from "../../../assets/img/svg/filter-icon.svg";
import downloadIcon from "../../../assets/img/svg/csv.svg";

import "./listHeader.css";

const ListHeading = ({
  title,
  handleSearch,
  onFilterClick,
  onDownloadClick,
  hasActiveFilters,
  showDownload = true,
  showFilter = true,
  showSearch = true,
  placeholder = "Search",
}) => {
  return (
    <div className="list-header">
      <div className="left-header">
        <h2>{title}</h2>
        {showSearch && (
          <div className="search-bar">
            <img src={searchIcon} alt="search icon" className="search-icon" />
            <input
              type="text"
              placeholder={placeholder}
              onChange={(e) => handleSearch?.(e)}
            />
          </div>
        )}
      </div>
      <div className="right-header">
        <div className="action-icons">
          {showFilter && (
            <div
              className={`icon-container ${
                hasActiveFilters ? "active-filter" : ""
              }`}
              onClick={onFilterClick}
              title={
                hasActiveFilters
                  ? "Filter applied - Click to modify"
                  : "Filter data"
              }
            >
              <img src={filterIcon} alt="filter icon" className="action-icon" />
              {hasActiveFilters && <div className="filter-indicator"></div>}
            </div>
          )}
          {showDownload && (
            <div
              className="icon-container"
              onClick={onDownloadClick}
              title="Download CSV"
            >
              <img
                src={downloadIcon}
                alt="download icon"
                className="action-icon"
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ListHeading;
